/* Heon reco (reco team, 2026-09-26): the product page's "Picked for you" row (sections/heon-reco.liquid) and the order of
   the collection band under it (sections/heon-edit.liquid).

   1. Memory. Every product page adds the piece to a short history kept only in this browser (localStorage "hh-reco"):
      handle, its collections, price, category, how often and when it was seen; the collections the shopper came from
      (the referring /collections/ page); the metal they pick (Yellow / White / Rose Gold on the page or a card's dot).
      No personal data, nothing sent anywhere. At most 30 pieces and 20 collections, nothing older than 30 days.
   2. The row. When it comes within ~1.5 screens it reads, in parallel: the catalogue (sections/heon-reco-data on
      /collections/all, best sellers first; kept 6 hours in localStorage), Shopify's related and complementary picks for
      this piece, and /cart.js. Every available piece except this one is scored (see score()), the list is spread out
      so it isn't 20 near-identical chains (diversify()), and the site's own cards are fetched one by one in rank order
      (sections/heon-reco-card) into frames that already hold their place.
   3. Scrolling. Touch: the finger scrolls freely with its own momentum and the row then settles on the nearest card
      edge. Mouse: drag with a throw, arrows, trackpad; always coming to rest on a card edge. Keyboard: ← → Home End.
   4. The band. Its tiles are ordered by what the shopper browsed and what goes with this piece; the first five show,
      and its videos play only while on screen (never with reduced motion or Save-Data). */
(() => {
  'use strict';
  const T = (k, d) => { const s = window.HeonI18n && window.HeonI18n[k]; return typeof s === 'string' && s ? s : d; };   // the page's language (snippets/heon-i18n-js), else the English default
  const TN = (k, n, d) => { let f = 'other'; try { f = new Intl.PluralRules(document.documentElement.lang || 'en').select(n); } catch (e) {} return T(k + (f === 'one' ? '_one' : '_other'), d).replace('[n]', n); };
  if (window.__hhReco) return; window.__hhReco = 1;               // both sections load this file
  const LS = 'hh-reco', V = 1, DAY = 864e5, NOW = Date.now();
  const store = {
    get() { try { const d = JSON.parse(localStorage.getItem(LS) || 'null'); if (d && d.v === V) return d; } catch (e) {} return { v: V, views: [], colls: {}, metals: {} }; },
    put(d) { try { localStorage.setItem(LS, JSON.stringify(d)); } catch (e) {} }
  };
  const readJSON = el => { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  const row = document.querySelector('[data-hr-row]');
  const band = document.querySelector('[data-hr-edit]');
  const ctxEl = document.querySelector('[data-hr-ctx]') || document.querySelector('[data-he-ctx]');
  const ctx = ctxEl ? readJSON(ctxEl) : null;
  const debug = /[?&]hr-debug/.test(location.search);
  if (!ctx || !ctx.h) return;

  /* ---------- features of a piece, from its title and collections ---------- */
  const CAT = c => {
    const has = re => c.some(h => re.test(h));
    return has(/(^|-)rings$/) ? 'ring' : has(/(^|-)earrings$/) ? 'earring' : has(/(^|-)bracelets$/) ? 'bracelet' : has(/(^|-)chains$/) && !has(/paperclip-chains|cuban-chains|rolo-chains/) || has(/solid-gold-chains$/) ? 'chain' : 'pendant';
  };
  const MOTIF = [['eye', /evil eye/], ['hamsa', /hamsa/], ['clover', /clover/], ['star', /\b(north star|compass star|star)\b/], ['sun', /\bsun\b|sunburst/],
    ['moon', /\bmoon\b/], ['tree', /tree of life/], ['olive', /olive/], ['bee', /\bbee\b/], ['mushroom', /mushroom/], ['sea', /starfish|shell/],
    ['flower', /plumeria|flower|daisy/], ['heart', /heart/], ['cross', /\bcross\b/], ['horn', /\bhorn\b/], ['horseshoe', /horseshoe/],
    ['animal', /elephant|\bcat\b|paw|snake ring/], ['infinity', /infinity/], ['family', /mom|baby|feet/], ['disc', /\bdisc\b|circle/]];
  const STONE = [['ruby', /ruby/], ['sapphire', /sapphire/], ['emerald', /emerald/], ['topaz', /topaz/], ['citrine', /citrine/], ['amethyst', /amethyst/],
    ['cz', /\bcz\b|cubic/], ['birth', /birthstone/]];
  const STYLE = [['paperclip', /paperclip/], ['cuban', /cuban|curb/], ['rolo', /rolo|belcher/], ['rope', /rope/], ['box', /\bbox\b/], ['ball', /\bball\b|bead/],
    ['popcorn', /popcorn/], ['cable', /cable/], ['herringbone', /herringbone/], ['mariner', /mariner/], ['twist', /twist/], ['link', /oval link|infinity link/],
    ['hoop', /hoop/], ['huggie', /huggie/], ['stud', /\bstuds?\b/], ['halo', /halo/], ['dome', /dome/], ['band', /\bband\b|stacking/], ['bubble', /bubble/],
    ['solitaire', /solitaire/], ['pave', /pav[eé]/]];
  const BROAD = /(^|-)(all|gifts)$/;
  const THEMED = /birthstone|heart|symbol|paperclip|cuban|rolo/;
  const tags = (t, list) => { const s = new Set(); for (const [k, re] of list) if (re.test(t)) s.add(k); return s; };
  function feat(x) {
    if (x._f) return x;
    // theme i18n (2026-09-28): e = the English title on a page in another language (the words below are English)
    const t = (x.e || x.t || '').toLowerCase(), c = (x.c || []).filter(h => !BROAD.test(h));
    x.k = CAT(x.c || []); x.cs = c; x.mo = tags(t, MOTIF); x.st = tags(t, STONE); x.sy = tags(t, STYLE);
    if (x.st.has('ruby') || x.st.has('sapphire') || x.st.has('emerald') || x.st.has('topaz') || x.st.has('citrine') || x.st.has('amethyst')) x.st.add('colour');
    x.fam = x.k + ':' + ([...x.sy][0] || [...x.mo][0] || [...x.st][0] || x.h);
    x._f = 1; return x;
  }
  const jac = (a, b) => { if (!a.size || !b.size) return 0; let i = 0; for (const v of a) if (b.has(v)) i++; return i / (a.size + b.size - i); };
  const wj = (a, b) => {   // collections, themed ones count three times as much as the broad categories
    const w = h => THEMED.test(h) ? 1.5 : .5; let i = 0, u = 0; const B = new Set(b);
    for (const h of new Set([...a, ...b])) { u += w(h); if (a.includes(h) && B.has(h)) i += w(h); }
    return u ? i / u : 0;
  };
  function sim(a, b) {
    return (a.k === b.k ? .3 : 0) + .2 * wj(a.cs, b.cs) + .25 * jac(a.mo, b.mo) + .15 * jac(a.st, b.st) + .1 * jac(a.sy, b.sy);
  }
  // what goes with what: a pendant with earrings, a chain with a bracelet ... stronger when the symbol or stone matches
  const COMP = { pendant: { earring: 1, bracelet: .6, ring: .5, chain: .45 }, chain: { bracelet: 1, pendant: .7, earring: .5, ring: .3 },
    earring: { pendant: 1, ring: .7, bracelet: .5, chain: .3 }, ring: { earring: .9, bracelet: .8, pendant: .6, chain: .3 },
    bracelet: { ring: .9, chain: .7, earring: .6, pendant: .5 } };
  function comp(a, b) {
    const c = (COMP[a.k] || {})[b.k] || 0;
    return c && c * (jac(a.mo, b.mo) + jac(a.st, b.st) > 0 ? 1 : .35);
  }

  /* ---------- 1. memory ---------- */
  // theme i18n (2026-09-28): on a page in another language a metal button's value is translated ("or jaune"); the
  // gallery lists the metals (data-hp-metals) with their English first words (data-hh-mw) in the same order
  const enMetal = s => {
    const g = document.querySelector('media-gallery[data-hh-mw]'); if (!g) return s;
    const i = (g.dataset.hpMetals || '').toLowerCase().split('|').indexOf(s);
    return i > -1 ? (g.dataset.hhMw.split('|')[i] || s) : s;
  };
  const metalKey = s => { s = enMetal(String(s || '').toLowerCase()); return /white/.test(s) ? 'w' : /rose/.test(s) ? 'r' : /yellow/.test(s) ? 'y' : ''; };
  function prune(d) {
    d.views = (d.views || []).filter(x => x && NOW - x.t < 30 * DAY).slice(0, 30);
    d.colls = d.colls || {}; d.metals = d.metals || {};
    const cs = Object.entries(d.colls).filter(([, v]) => NOW - v[1] < 30 * DAY).sort((a, b) => b[1][1] - a[1][1]).slice(0, 20);
    d.colls = Object.fromEntries(cs);
    for (const k in d.metals) if (NOW - d.metals[k][1] > 30 * DAY) delete d.metals[k];
    return d;
  }
  const bumpColl = (d, h, w = 1) => { if (!h || BROAD.test(h)) return; const v = d.colls[h] || [0, 0]; d.colls[h] = [Math.min(20, v[0] + w), NOW]; };
  const bumpMetal = (d, k, w = 1) => { if (!k) return; const v = d.metals[k] || [0, 0]; d.metals[k] = [Math.min(20, v[0] + w), NOW]; };
  const mem = prune(store.get());
  const history = mem.views.filter(v => v.h !== ctx.h);          // what was seen before this page
  (function record() {
    const prev = mem.views.find(v => v.h === ctx.h);
    const fresh = !prev || NOW - prev.t > 30 * 60e3;               // a reload within 30 minutes is the same visit
    mem.views = [{ h: ctx.h, t: NOW, n: (prev ? prev.n : 0) + (fresh ? 1 : 0), c: (ctx.c || []).filter(h => !BROAD.test(h)), p: ctx.p }]
      .concat(mem.views.filter(v => v.h !== ctx.h)).slice(0, 30);
    if (fresh) {
      try {
        const r = new URL(document.referrer);
        const m = r.origin === location.origin && r.pathname.match(/^\/collections\/([^/?#]+)/);
        if (m) bumpColl(mem, decodeURIComponent(m[1]));
      } catch (e) {}
      const w = location.pathname.match(/^\/collections\/([^/]+)\/products\//);
      if (w) bumpColl(mem, decodeURIComponent(w[1]), .5);
      if (ctx.sel) bumpMetal(mem, ctx.sel, 1);                   // arrived on a chosen metal (a card's dot, a link)
    }
    store.put(mem);
  })();
  // metal picks: the product page's own metal buttons (kept when leaving the page) and any card dot
  let chosen = '';
  document.addEventListener('change', e => {
    const t = e.target;
    if (!e.isTrusted || !t || t.type !== 'radio' || t.closest('[data-hr-row]')) return;
    const k = metalKey(t.value); if (k) chosen = k;
  }, true);
  document.addEventListener('click', e => {
    if (!e.isTrusted) return;
    const b = e.target.closest && e.target.closest('.hh-sw .hh-y, .hh-sw .hh-w, .hh-sw .hh-r');
    if (!b) return;
    const d = store.get(); bumpMetal(prune(d), b.classList.contains('hh-w') ? 'w' : b.classList.contains('hh-r') ? 'r' : 'y', .5); store.put(d);
  }, true);
  const leave = () => { if (!chosen) return; const d = prune(store.get()); bumpMetal(d, chosen, 1); store.put(d); chosen = ''; };
  addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') leave(); });

  // weight of each earlier piece: halves every 7 days, a little more for pieces opened again
  const hw = v => Math.pow(.5, (NOW - v.t) / (7 * DAY)) * (1 + .25 * Math.min(4, (v.n || 1) - 1));
  const histWeight = history.reduce((s, v) => s + hw(v), 0);
  const eta = Math.min(1, histWeight / 2.5);                      // 0 = first visit, 1 = a clear history
  function metalPref() {
    const e = Object.entries(mem.metals).map(([k, v]) => [k, v[0] * Math.pow(.5, (NOW - v[1]) / (14 * DAY))]);
    const tot = e.reduce((s, x) => s + x[1], 0); if (tot < 1) return null;
    e.sort((a, b) => b[1] - a[1]);
    return e[0][1] / tot >= .6 ? { k: e[0][0], sure: e[0][1] >= 1.5 } : null;
  }

  /* ---------- 4. the band: order its tiles ---------- */
  function orderBand() {
    if (!band) return;
    const list = band.querySelector('.he-grid'); if (!list) return;
    const tiles = [...list.querySelectorAll('.he-tile')];
    const me = feat({ h: ctx.h, t: ctx.t, e: ctx.e, c: ctx.c || [] });
    const catOf = { '14k-solid-gold-earrings': 'earring', '14k-solid-gold-rings': 'ring', '14k-solid-gold-bracelets': 'bracelet', '14k-solid-gold-chains': 'chain', '14k-solid-gold-necklaces': 'pendant' };
    const collW = {}; let maxW = 0;
    for (const v of history) for (const h of v.c || []) { collW[h] = (collW[h] || 0) + hw(v); }
    for (const [h, v] of Object.entries(mem.colls)) collW[h] = (collW[h] || 0) + 1.5 * v[0] * Math.pow(.5, (NOW - v[1]) / (7 * DAY));
    for (const h in collW) maxW = Math.max(maxW, collW[h]);
    tiles.forEach((t, i) => {
      const h = t.dataset.coll, k = catOf[h];
      let s = (maxW ? (collW[h] || 0) / maxW : 0) * (.4 + .6 * eta);
      if (k) s += .5 * ((COMP[me.k] || {})[k] || 0);
      if (h && /symbol/.test(h) && me.mo.size) s += .15;
      if (h && /birthstone/.test(h) && me.st.has('colour')) s += .15;
      t._s = s + (tiles.length - i) * .01;                         // the editor's order breaks ties
    });
    const n = +band.dataset.show || 5;
    const sorted = tiles.slice().sort((a, b) => b._s - a._s);
    sorted.forEach((t, i) => { t.hidden = i >= n; list.appendChild(t); });
    band.dataset.n = Math.min(n, sorted.length);
    // the first tile is the large one: its photo and film come in the larger size (nothing has loaded yet: lazy)
    const big = sorted[0], img = big && big.querySelector('.he-media img'), bv = big && big.querySelector('video[data-src-big]');
    if (img && big.dataset.bigSizes) img.sizes = big.dataset.bigSizes;
    if (bv) bv.dataset.src = bv.dataset.srcBig;
    band.classList.add('is-ordered');
    if (debug) console.log('hr band', sorted.map(t => t.dataset.coll + ':' + t._s.toFixed(2)).join(' '));
    videos(sorted.slice(0, n));
  }
  function videos(tiles) {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection && navigator.connection.saveData;
    const maxV = band && band.dataset.videos !== '' && band.dataset.videos != null ? +band.dataset.videos : 2;
    const vids = tiles.map(t => t.querySelector('video[data-src]')).filter(Boolean).slice(0, maxV);
    tiles.forEach(t => { const v = t.querySelector('video[data-src]'); if (v && !vids.includes(v)) v.remove(); });
    if (!vids.length || reduce.matches || saveData || !('IntersectionObserver' in window)) { vids.forEach(v => v.remove()); return; }
    const io = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target;
      if (e.isIntersecting) {
        if (!v.src) {
          v.addEventListener('error', () => {                      // the smaller file missing: the full one, else the photo
            if (v.dataset.srcBig && !v.src.endsWith(v.dataset.srcBig)) { v.src = v.dataset.srcBig; v.load(); v.play().catch(() => {}); }
            else v.remove();
          });
          v.src = v.dataset.src; v.load();
        }
        const p = v.play(); if (p && p.catch) p.catch(() => {});
        v.addEventListener('playing', () => v.closest('.he-tile').classList.add('is-playing'), { once: true });
      } else if (!v.paused) v.pause();
    }), { threshold: .25 });
    vids.forEach(v => io.observe(v));
    reduce.addEventListener && reduce.addEventListener('change', () => { if (reduce.matches) vids.forEach(v => { v.pause(); v.closest('.he-tile').classList.remove('is-playing'); }); });
  }
  orderBand();

  if (!row) return;
  /* ---------- 2. the row ---------- */
  const track = row.querySelector('.hr-track'), list = row.querySelector('.hr-list');
  const N = Math.max(20, +row.dataset.count || 24);
  if (histWeight > 0) {                                            // the heading says whose row it is
    const h = row.querySelector('.hr-h'), sub = row.querySelector('.hr-sub');
    if (h && h.dataset.hrH) { h.textContent = h.dataset.hrH; track.setAttribute('aria-label', h.dataset.hrH); }
    if (sub && sub.dataset.hrSub) sub.textContent = sub.dataset.hrSub;
    row.classList.add('is-personal');
  }

  const section = (url, ttl, key) => {
    if (key) { try { const c = JSON.parse(localStorage.getItem(key) || 'null'); if (c && NOW - c.t < ttl) return Promise.resolve(c.d); } catch (e) {} }
    return fetch(url, { credentials: 'same-origin' }).then(r => r.ok ? r.text() : '').then(t => {
      const m = t.match(/<script[^>]*data-hr-data[^>]*>([\s\S]*?)<\/script>/);
      const d = m ? JSON.parse(m[1]) : null;
      if (d && key) { try { localStorage.setItem(key, JSON.stringify({ t: NOW, d })); } catch (e) {} }
      return d;
    }).catch(() => null);
  };
  const cacheGet = k => { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const cachePut = (k, v) => { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };

  function score(cat, rel, compl, cart) {
    const me = feat({ h: ctx.h, t: ctx.t, e: ctx.e, c: ctx.c || [], p: ctx.p });
    const nAll = cat.length, relIx = new Map(rel.map((h, i) => [h, i])), compIx = new Map(compl.map((h, i) => [h, i]));
    const byH = new Map(cat.map(x => [x.h, feat(x)]));
    const hist = history.map(v => ({ v, x: byH.get(v.h), w: hw(v) })).filter(o => o.x);
    const hw0 = hist.reduce((s, o) => s + o.w, 0) || 1;
    // the price the shopper looks at: geometric mean of this piece and the history
    let lp = Math.log(ctx.p || 20000), lw = 1;
    for (const o of hist) { lp += o.w * Math.log(o.x.p || ctx.p || 20000); lw += o.w; }
    const pref = Math.exp(lp / lw);
    const catW = {}; for (const o of hist) catW[o.x.k] = (catW[o.x.k] || 0) + o.w;
    const collW = {}; let maxC = 0;
    for (const [h, v] of Object.entries(mem.colls)) { collW[h] = v[0] * Math.pow(.5, (NOW - v[1]) / (7 * DAY)); maxC = Math.max(maxC, collW[h]); }
    const mp = metalPref();
    const cartX = cart.map(h => byH.get(h)).filter(Boolean);
    const seen = new Set(history.map(v => v.h));
    const out = [];
    cat.forEach((x, rank) => {
      if (x.h === ctx.h || cart.includes(x.h)) return;
      const f = {
        rel: relIx.has(x.h) ? 1 - relIx.get(x.h) / 10 : 0,
        sim: sim(me, x),
        comp: Math.max(comp(me, x), compIx.has(x.h) ? 1 - compIx.get(x.h) / 20 : 0),
        pop: 1 - rank / nAll,
        price: Math.exp(-Math.pow(Math.log((x.p || pref) / pref), 2) / (2 * .5 * .5)),
        hist: hist.reduce((s, o) => s + o.w * sim(o.x, x), 0) / hw0,
        cat: (catW[x.k] || 0) / hw0,
        coll: maxC ? Math.min(1, x.cs.reduce((s, h) => s + (collW[h] || 0), 0) / maxC) : 0,
        metal: mp ? (x.m || '').includes(mp.k) ? 1 : -1 : 0,
        cart: cartX.reduce((s, y) => Math.max(s, comp(y, x)), 0)
      };
      const first = .30 * f.rel + .25 * f.sim + .15 * f.comp + .20 * f.pop + .10 * f.price;
      const known = .12 * f.rel + .10 * f.sim + .08 * f.comp + .30 * f.hist + .14 * f.cat + .08 * f.coll + .08 * f.pop + .10 * f.price;
      // a set the shop has matched by hand (Search & Discovery "complementary products": same symbol, stone or link)
      // stays near the front whatever the history says
      const set = compIx.has(x.h) ? 1 - compIx.get(x.h) / 10 : 0;
      let s = (1 - eta) * first + eta * known + .2 * set + .04 * f.metal + .05 * f.cart;
      if (seen.has(x.h)) s *= .8;                                   // seen already: still welcome, a little lower
      if (x.k === me.k && x.fam === me.fam) s *= .55;                // the same design as this piece in another listing
      out.push({ x, s, f, set });
    });
    return out.sort((a, b) => b.s - a.s);
  }
  // spread the list: a piece loses points for looking like what is already picked, and for a third of the same design
  function diversify(scored, n) {
    const pool = scored.slice(), picked = [];
    while (picked.length < n && pool.length) {
      let best = -Infinity, bi = 0;
      for (let i = 0; i < Math.min(pool.length, 80); i++) {
        const o = pool[i];
        let red = 0, fam = 0;
        for (const p of picked) { red = Math.max(red, sim(o.x, p.x)); if (p.x.fam === o.x.fam) fam++; }
        const l = picked.length, run = l >= 2 && picked[l - 1].x.k === o.x.k && picked[l - 2].x.k === o.x.k ? .06 : 0;
        const v = o.s - (o.set ? .5 : 1) * (.22 * red + .1 * fam) - run;   // a hand-matched set is spared half the penalty
        if (v > best) { best = v; bi = i; }
      }
      const o = pool.splice(bi, 1)[0]; o.v = best; picked.push(o);
    }
    return picked;
  }

  let built = false;
  async function build() {
    if (built) return; built = true;
    row.classList.add('is-loading');
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const recs = intent => {
      const k = 'hh-reco-r-' + intent + '-' + ctx.id, c = cacheGet(k);
      if (c) return Promise.resolve(c);
      return section(`${base}recommendations/products?product_id=${ctx.id}&limit=10&intent=${intent}&section_id=heon-reco-data`).then(d => { const r = d && d.r || []; cachePut(k, r); return r; });
    };
    const [catD, rel, compl, cart] = await Promise.all([
      section(`${base}collections/all?sort_by=best-selling&section_id=heon-reco-data`, 6 * 36e5, 'hh-reco-cat'),
      recs('related'), recs('complementary'),
      fetch(`${base}cart.js`, { credentials: 'same-origin' }).then(r => r.json()).then(c => (c.items || []).map(i => i.handle)).catch(() => [])
    ]);
    let cat = catD && catD.p || [];
    if (!cat.length) {                                             // no catalogue: Shopify's picks alone
      cat = rel.map(h => ({ h, t: h.replace(/-/g, ' '), c: [], p: 0, m: '' }));
    }
    // a few spares stand behind the row: a piece that has just gone (sold out, hidden) is replaced by the next one
    const ranked = diversify(score(cat, rel, compl, cart), N + 6);
    const picked = ranked.slice(0, N), spares = ranked.slice(N);
    if (!picked.length) { row.hidden = true; return; }
    if (debug) console.table(picked.map((o, i) => ({ i, h: o.x.h, k: o.x.k, s: +o.s.toFixed(3), v: +o.v.toFixed(3), ...Object.fromEntries(Object.entries(o.f).map(([k, v]) => [k, +v.toFixed(2)])) })));
    row.dataset.order = picked.map(o => o.x.h).join(',');
    // frames for every card first, so the row has its full length and never moves while cards arrive
    const frames = picked.map((o, i) => {
      let li = list.children[i];
      if (!li) { li = document.createElement('li'); li.className = 'hr-item hr-ph'; li.setAttribute('aria-hidden', 'true'); li.innerHTML = '<span class="hr-ph-img"></span><span class="hr-ph-l"></span><span class="hr-ph-l hr-ph-l2"></span>'; list.appendChild(li); }
      li.dataset.h = o.x.h; return li;
    });
    while (list.children.length > frames.length) list.lastElementChild.remove();
    measure();
    const CK = 'hh-reco-card:', shown = new Set([ctx.h]);
    const one = async (li, h) => {
      let html = null; const c = cacheGet(CK + h);
      if (c && NOW - c.t < 30 * 60e3) html = c.html;
      if (html == null) {
        html = await fetch(`${base}products/${encodeURIComponent(h)}?section_id=heon-reco-card`, { credentials: 'same-origin' })
          .then(r => r.ok ? r.text() : '').catch(() => '');
        const m = html.match(/<li class="hr-item"[\s\S]*<\/li>/);
        html = m ? m[0] : '';
        if (html) cachePut(CK + h, { t: NOW, html });
      }
      const tpl = document.createElement('template'); tpl.innerHTML = html || '';
      const card = tpl.content.firstElementChild;
      const got = card && card.dataset.h;                          // a moved listing answers with another handle
      if (!got || shown.has(got)) {
        const sp = spares.shift();
        if (sp) { li.dataset.h = sp.x.h; return one(li, sp.x.h); }
        li.remove(); return;
      }
      shown.add(got);
      if (debug) { const o = ranked.find(p => p.x.h === h); card.dataset.score = o ? o.s.toFixed(3) : ''; }
      li.replaceWith(card);
      seeCard(card);
    };
    // six at a time, best first
    let next = 0;
    const worker = async () => { while (next < frames.length) { const i = next++; await one(frames[i], picked[i].x.h); } };
    await Promise.all(Array.from({ length: 6 }, worker));
    row.dataset.order = [...list.children].map(li => li.dataset.h).join(',');
    row.classList.remove('is-loading'); row.classList.add('is-ready');
    const st = row.querySelector('.hr-status'); if (st) st.textContent = TN('pieces', list.children.length, '[n] pieces');
    measure();
  }

  // a preferred metal other than yellow: each card turns to it as it comes into view (its own dot, heon-cards.js)
  const mp = metalPref();
  const seeIO = mp && mp.sure && mp.k !== 'y' && 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const li = e.target, dot = li.querySelector(`.hh-sw--live button.hh-${mp.k}`), box = li.querySelector('.hh-cm-metal');
    if (!dot) { seeIO.unobserve(li); return; }
    if (!box || !box.dataset.ready) return;                        // the card script hasn't wired it yet: next time
    seeIO.unobserve(li);
    if (dot.getAttribute('aria-checked') !== 'true') dot.click();
  }), { root: track, rootMargin: '0px 200px' }) : null;
  const seeCard = li => { if (seeIO) seeIO.observe(li); };

  /* ---------- 3. scrolling ---------- */
  const prev = row.querySelector('.hr-prev'), nextB = row.querySelector('.hr-next'), nav = row.querySelector('.hr-nav');
  const bar = row.querySelector('.hr-bar span');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => reduce.matches ? 'auto' : 'smooth';
  let stops = [];
  function measure() {
    const pl = parseFloat(getComputedStyle(track).paddingLeft) || 0, max = track.scrollWidth - track.clientWidth;
    stops = [...list.children].map(li => Math.min(max, Math.max(0, li.offsetLeft - pl)));
    stops.push(max); stops = [...new Set(stops.map(Math.round))].sort((a, b) => a - b);
    update();
  }
  function nearest(x, dir = 0) {
    if (!stops.length) return x;
    if (dir > 0) return stops.find(s => s > x + 2) ?? stops[stops.length - 1];
    if (dir < 0) return [...stops].reverse().find(s => s < x - 2) ?? 0;
    return stops.reduce((b, s) => Math.abs(s - x) < Math.abs(b - x) ? s : b, stops[0]);
  }
  function update() {
    const max = track.scrollWidth - track.clientWidth, x = track.scrollLeft;
    if (nav) nav.hidden = max <= 2;
    if (prev) prev.disabled = x <= 2;
    if (nextB) nextB.disabled = x >= max - 2;
    if (bar) {
      const f = Math.min(1, track.clientWidth / (track.scrollWidth || 1));
      bar.style.width = (f * 100) + '%';
      bar.style.transform = `translateX(${max > 0 ? (x / max) * ((1 - f) / f) * 100 : 0}%)`;
    }
  }
  let glideTo = null;
  function go(x) {
    glideTo = x;
    track.classList.add('is-gliding');                             // CSS snapping off while the script moves the row
    track.scrollTo({ left: x, behavior: behavior() });
    clearTimeout(go.t); go.t = setTimeout(done, 900);
  }
  function done() { clearTimeout(go.t); glideTo = null; track.classList.remove('is-gliding'); }
  // one page: as many whole cards as are fully visible
  function page(dir) {
    const x = track.scrollLeft, w = track.clientWidth - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    const target = dir > 0 ? [...stops].reverse().find(s => s <= x + w - 8 && s > x + 2) ?? nearest(x, 1) : stops.find(s => s >= x - w + 8 && s < x - 2) ?? nearest(x, -1);
    go(target);
  }
  prev && prev.addEventListener('click', () => page(-1));
  nextB && nextB.addEventListener('click', () => page(1));
  track.addEventListener('keydown', e => {
    if (e.target !== track) return;
    const k = e.key;
    if (k === 'ArrowRight' || k === 'ArrowLeft') { e.preventDefault(); go(nearest(glideTo ?? track.scrollLeft, k === 'ArrowRight' ? 1 : -1)); }
    else if (k === 'Home') { e.preventDefault(); go(0); }
    else if (k === 'End') { e.preventDefault(); go(stops[stops.length - 1] || 0); }
  });
  // a card reached with Tab comes fully into view
  track.addEventListener('focusin', e => {
    const li = e.target.closest && e.target.closest('.hr-item'); if (!li || e.target === track) return;
    const pl = parseFloat(getComputedStyle(track).paddingLeft) || 0, x = track.scrollLeft;
    const l = li.offsetLeft - pl, r = li.offsetLeft + li.offsetWidth - track.clientWidth + pl;
    if (l < x || li.offsetLeft + li.offsetWidth > x + track.clientWidth) { e.preventDefault && 0; go(nearest(l < x ? l : r + 1, l < x ? 0 : 1)); }
  });
  let raf = 0;
  track.addEventListener('scroll', () => {
    if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); });
    if (!fine.matches && !drag) { clearTimeout(settleT); settleT = setTimeout(settle, 140); }
  }, { passive: true });
  // touch: the row runs free with the finger's momentum and then comes to rest on the nearest card edge
  let settleT = 0, touching = false;
  track.addEventListener('touchstart', () => { touching = true; clearTimeout(settleT); if (glideTo != null) done(); }, { passive: true });
  track.addEventListener('touchend', () => { touching = false; clearTimeout(settleT); settleT = setTimeout(settle, 140); }, { passive: true });
  track.addEventListener('scrollend', () => { if (glideTo != null && Math.abs(track.scrollLeft - glideTo) < 3) done(); if (!fine.matches) settle(); });
  function settle() {
    if (touching || drag || glideTo != null) return;
    const x = track.scrollLeft, s = nearest(x);
    if (Math.abs(s - x) > 2) go(s);
  }
  // mouse: drag with a throw, landing on a card edge; a drag is never a click
  let drag = null, eat = false;
  track.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    drag = { x0: e.clientX, s0: track.scrollLeft, moved: false, trail: [[performance.now(), e.clientX]] };
  });
  addEventListener('pointermove', e => {
    if (!drag) return;
    const dx = e.clientX - drag.x0;
    if (!drag.moved) { if (Math.abs(dx) < 6) return; drag.moved = true; if (glideTo != null) done(); track.classList.add('is-dragging', 'is-gliding'); }
    track.scrollLeft = drag.s0 - dx;
    drag.trail.push([performance.now(), e.clientX]); if (drag.trail.length > 12) drag.trail.shift();
  });
  const endDrag = () => {
    if (!drag) return;
    const d = drag; drag = null;
    if (!d.moved) return;
    eat = true; setTimeout(() => { eat = false; }, 0);
    const now = performance.now(), t = d.trail.filter(p => now - p[0] < 100);
    const v = t.length < 2 ? 0 : (t[t.length - 1][1] - t[0][1]) / Math.max(1, t[t.length - 1][0] - t[0][0]);
    track.classList.remove('is-dragging');
    const aim = track.scrollLeft - v * 300, dir = Math.sign(track.scrollLeft - d.s0);
    // a small, slow pull still moves on by one card in the pulled direction
    let s = nearest(aim);
    if (s === nearest(d.s0) && Math.abs(track.scrollLeft - d.s0) > 30) s = nearest(d.s0, dir);
    go(s);
  };
  addEventListener('pointerup', endDrag); addEventListener('pointercancel', endDrag);
  track.addEventListener('click', e => { if (eat) { e.preventDefault(); e.stopPropagation(); eat = false; } }, true);
  track.addEventListener('dragstart', e => e.preventDefault());
  // trackpad / wheel sideways: free, then rests on a card edge
  track.addEventListener('wheel', e => {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    if (glideTo != null) done();
    clearTimeout(settleT); settleT = setTimeout(() => { if (!fine.matches) return; const x = track.scrollLeft, s = nearest(x); if (Math.abs(s - x) > 2) go(s); }, 180);
  }, { passive: true });
  addEventListener('resize', () => { clearTimeout(measure.t); measure.t = setTimeout(measure, 150); });
  measure();

  // start when the row is about a screen and a half away
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); build(); } }, { rootMargin: '0px 0px 150% 0px' });
    io.observe(row);
  } else build();
})();
